export default __webpack_public_path__ + "static/media/F3CCF27C-00.ffbdba0f.png";